import { get } from "../api.js";

/**
 * Gets list of Contract Holders
 * @returns {Promise<ContractHolder[]>}
 */
export const getContractHoldersList = () => get("/sewp5public/contractholders/contractholderslist")
.then(({ data }) => data);

/**
 * Gets list of Contract Holders Groups
 * @param {boolean} [fedRamp=false]
 * @returns {Promise<ContractHolderGroup[]>}
 */
export const getContractHoldersGroups = (fedRamp = false) => {
  if (fedRamp) {
    return get("/sewp5public/contractholders/groups?page=FedRamp").then(({ data }) => data);
  } else {
    return get("/sewp5public/contractholders/groups").then(({ data }) => data);
  }
};

/**
 * Gets Contract Holder Details data
 * @param {number} contractHolderId
 * @returns {Promise<ContractHolderDetails>}
 */
export const getContractHolderDetails = (contractHolderId) => get(
  `/sewp5public/contractholders/contractholder/${contractHolderId}`).then(({ data }) => data);

/**
 * Gets list of Contract Holder Program Managers
 * @returns {Promise<ProgramManager[]>}
 */
export const getProgramManagers = () => get("/sewp5public/contractholders/programmanagerslist")
.then(({ data }) => data);

/**
 * Gets list of Small Business Contract Holders
 * @returns {Promise<SmallBusiness[]>}
 */
export const getSmallBusinesses = () => get("/sewp5public/contractholders/smallbusinesslist").then(({ data }) => data);

/**
 * Gets list of Business Breakdown group counts
 * @returns {Promise<GroupCount[]>}
 */
export const getGroupCounts = () => get("/sewp5public/contractholders/groupcounts").then(({ data }) => data);

/**
 * Gets list of Business Breakdown business size counts
 * @returns {Promise<BusinessSizeCount[]>}
 */
export const getBusinessSizeCounts = () => get("/sewp5public/contractholders/businesssizecounts")
.then(({ data }) => data);
